module.exports = __webpack_public_path__ + "img/plan3_book04.34cfdf18.png";